import { render, staticRenderFns } from "./DoctorRegisterHospitalList.vue?vue&type=template&id=46fd976d&scoped=true&"
import script from "./DoctorRegisterHospitalList.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterHospitalList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterHospitalList.vue?vue&type=style&index=0&id=46fd976d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd976d",
  null
  
)

export default component.exports